import React, { useState, useEffect } from "react";
import { fetchDadosFinanceiro } from "../../integration/dados_financeiro/fetchDadosFinanceiro";
import {
  AiOutlinePercentage,
  AiOutlineShoppingCart,
  AiOutlineCheckCircle,
  AiOutlineClockCircle,
  AiOutlineDollar
} from "react-icons/ai";
import { formatToBRL } from "brazilian-values";

const FinancialSummary = () => {
  const [dataConversao, setDataConversao] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    funcConversaoPix();
  }, []);

  async function funcConversaoPix() {
    try {
      setLoading(true);
      const resp = await fetchDadosFinanceiro();
      setDataConversao(resp);
    } finally {
      setLoading(false);
    }
  }

  const formatMoney = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value || 0);

  return (
    <div className="grid grid-cols-3 gap-y-10 gap-x-4 w-full max-w-4xl mx-auto p-5 bg-white sm:bg-[#f2f2f2] rounded-lg shadow-md">
      {/* Total de Vendas */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center -mt-11 items-center bg-[#f7f7f7] text-slate-500 rounded-full border border-slate-300 p-4">
          <AiOutlineDollar size={20} />
        </div>
        <span className="text-lg font-semibold text-gray-600 mt-3">
          {loading ? "carregando..." : dataConversao.total_vendas}
        </span>
        <span className="text-xs font-light text-gray-500">PIX Gerados</span>
      </div>

      {/* Total Pago */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center -mt-11 items-center bg-[#f7f7f7] text-slate-500 rounded-full border border-slate-300 p-4">
          <AiOutlineCheckCircle size={20} />
        </div>
        <span className="text-lg font-semibold text-gray-600 mt-3">
          {loading
            ? "carregando..."
            : formatToBRL(dataConversao.total_pago / 100)}
        </span>
        <span className="text-xs font-light text-gray-500">Total Pago</span>
      </div>

      {/* Conversão */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center -mt-11 items-center bg-[#f7f7f7] text-slate-500 rounded-full border border-slate-300 p-4">
          <AiOutlinePercentage size={20} />
        </div>
        <span className="text-lg font-semibold text-gray-600 mt-3">
          {loading ? "carregando..." : dataConversao.conversao}
        </span>
        <span className="text-xs font-light text-gray-500">
          Conversão (Hoje)
        </span>
      </div>
    </div>
  );
};

export default FinancialSummary;
